<mat-dialog-content id="content" class="flexColumnContainer">
  <mat-icon class="material-symbols-outlined">error</mat-icon>
  <p class="headline-small">{{ data.title | translate }}</p>
  <p class="body-medium">{{ data.message | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions id="actions">
  <button mat-flat-button mat-dialog-close cdkFocusInitial>{{ 'exceptions.fallback.modal.button.ok' | translate }}
  </button>
</mat-dialog-actions>
